module.exports = __webpack_public_path__ + "static/img/avatar.a314fac3.png";